lottery = {
    // Funkcia sluzi na preposielanie dat z offery do iframe loteriovych hier (Keno, LuckyLoot)
    sendDataToIframeLotteryGame: function(data, type, time, lotteryIframe) {
        /* 
            // aktulizacia game config a time
            lottery.sendDataToIframeLotteryGame(data, "sendDataToIframeLotteryGame", time, lotteryIframe);
            // reset inputov
            lottery.sendDataToIframeLotteryGame({target:"5019"}, "inputsReset", null, $("#624205Iframe"));
            lottery.sendDataToIframeLotteryGame({target:"5019,repeat"}, "inputsReset", null, $("#624205Iframe"));
            lottery.sendDataToIframeLotteryGame({target:""}, "inputsReset", null, $("#624205Iframe"));
         */
        try {
            if (lotteryIframe.length) {
                data.type = type;
                data.time = time;
                lotteryIframe.get(0).contentWindow.postMessage(data, "*");
                $("#eventsIframeWrapper").removeClass("ui-disabled").show();
                clearTimeout(rfs.LotteryGameSendDataTimer);
                rfs.LotteryGameSendDataTimer = setTimeout(function() {
                    service.loadPure("sportsBookEventsLotteryGames", null, true);
                }, 1 * 20 * 1000);
            }
        } catch (e) {
            clearTimeout(rfs.LotteryGameSendDataTimer);
            main.setPage(2);
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "sendDataToIframeLotteryGame", e);
            return false;
        }
    },

    // Loterove hry - Preposlanie dat do iframe pre zobrazenie
    eventsLotteryGamesSendToIframe: function(data, refresh) {
        try {
            if (!refresh && $("#eventsIframeWrapper .lottery-game-iframe").length) {
                // Jedna sa o 1. zobrazenie iframe alebo sa nejedna o opatovne posielanie dat do iframe
                $("#eventsIframeWrapper").hide().empty();
            }
            if (data && data.EventChanceTypes && data.EventChanceTypes.length) {
                var collectDataToIframeLotteryGame = function(time) {
                    if (!refresh) {
                        if (lotteryOffer && lotteryOffer["league" + String(offer.leagueCupID)]) {
                            data.lotteryOfferWinningTable = lotteryOffer["league" + String(offer.leagueCupID)];
                        }
                    }
                    var lotteryIframe = $("#" + offer.leagueCupID + "Iframe");
                    if (lotteryIframe.length) {
                        lottery.sendDataToIframeLotteryGame(data, "sendDataToIframeLotteryGame", time, lotteryIframe);
                    }
                };

                if (!refresh) {
                    var lotteryIframe = $("<iframe>", {
                        src: origin + "/games/" + offer.leagueCupID + ".html",
                        id:  offer.leagueCupID + "Iframe",
                        class: "lottery-game-iframe",
                        frameborder: 0,
                    }).appendTo("#eventsIframeWrapper");

                    lotteryIframe.load(function() {
                        if (profile.OddsCacheFeed) {
                            main.setClockOddsCache(collectDataToIframeLotteryGame);
                        } else {
                            main.setClock(collectDataToIframeLotteryGame);
                        }
                    });
                    return true;
                } else {
                    if (profile.OddsCacheFeed) {
                        main.setClockOddsCache(collectDataToIframeLotteryGame);
                    } else {
                        main.setClock(collectDataToIframeLotteryGame);
                    }
                }
            } else {
                clearTimeout(rfs.LotteryGameSendDataTimer);
                main.setPage(2);
                modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                main.createLog(2, "eventsLotteryGamesSendToIframeError", "NO EventChanceTypes");
                return false;
            }
        } catch (e) {
            clearTimeout(rfs.LotteryGameSendDataTimer);
            main.setPage(2);
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "eventsLotteryGamesSendToIframeError", "ERROR: " + e);
            return false;
        }
    },

    // Funkcia sluzi na ochytenie akcie playera po kliknuti na button vo vnutri (iframe) - loteriove hry
    listenGameIframe: function() {
        try {
            window.addEventListener('message', function(msg) {
                if (msg?.data !== 'onload') {
                    // Pocuva na postMessage len z loteriovych hier
                    if (msg.data?.type === "ballsPostMessage") {
                        try {

                            var data = msg.data?.payload;
                            var action = data.action;

                            console.warn(data);

                            switch (action) {

                                // pocuvam na message o aktivite usera v iframe 
                                case 'useraction':
                                    main.userAction(true);
                                    break;

                                case 'bet':
                                    ticket.ticketLotteryModule.ctAddOddLottery(data.EventID, data.gameid, data.data, data.timestamp);
                                    break;

                                case 'showHelpModal':
                                    var dataForModal = {
                                        header: texts['LotteryBetRulesModalHeader' + (data.gameid == 624205 ? "Keno" : "Luckyloot")],
                                        content: texts['LotteryBetRulesModalContent' + (data.gameid == 624205 ? "Keno" : "Luckyloot")] + lottery.eventDetailLottery.eventDetailLottery.getAllTables({LCUP: data.gameid})
                                    };
                                    modal.htmlModal.show('modal--lottery-info', dataForModal);
                                    break;

                                default:
                                    console.log('action');
                            }

                        } catch (e) {
                            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                            return false;
                        }
                    }
                }
            });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Objekt/Funkcia na nacitanie a zobrazenie detailu loterie priamo do listu zapasov
    eventDetailLottery: {
        // prepinanie css class stavu riadku a tlacidla
        toggle: function (element) {
            $(element).toggleClass('open');
            $(element).find(".btn-right").toggleClass('active');
            // check a zobrazenie scrollbar a tlačidiel ak treba
            shared.scrollModule.scrollButtons("ticket-status-odds");
        },

        // vygenerovanie tabulky vyhier
        getTable: function (data) {
            try {
                if (data) {
                    var tableHtml = "";
                    var rowHtml = "";
                    var tip = data.Tip;
                    // osetrenie pola tipov
                    tip = tip.split(",");
                    var tableData = {};

                    // Lucky Loot
                    if (data.LCUP == 624204) {
                        tableData = lotteryOffer.league624204.balls[tip.length];
                    }
                    // Keno
                    if (data.LCUP == 624205) {
                        tableData = lotteryOffer.league624205.balls[tip.length];
                    }

                    Object.entries(tableData).forEach(([key, value]) => {
                        rowHtml += `
                            <tr>
                                <td>${key.replace("hits_","")}</td>
                                <td><span class="chip">${shared.floor2(value.pays, 2)}</span></td>
                                <td>${shared.floor2(value.pays * data.Bet, 2)} ${profile.Currency}</td>
                            </tr>
                        `;
                    });

                    tableHtml = `
                        <tr class="lottery-detail">
                            <td colspan="8">
                                <div class="lottery-table">
                                    <table>
                                        <caption>${texts.LotteryBetTableCaptionWin}</caption>
                                        <thead>
                                            <tr>
                                                <th>${texts.LotteryBetTableHeaderHits}</th>
                                                <th>${texts.LotteryBetTableHeaderPays}</th>
                                                <th>${texts.LotteryBetTableHeaderEvWin}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${rowHtml}
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    `;

                    return tableHtml;
                }
            } catch (e) {
                main.createLog(2, "eventDetailLottery.getTable", " # ERROR: " + e);
                return false;
            }
        },

        // vygenerovanie tabulky vyhier - pre help modal
        getAllTables: function (data) {
            try {
                if (data) {
                    
                    var tableHtml = "";
                    var rowHtml = "";
                    var allData = [];
                    var allTablesHtml = "";
                    // premenne pre upravu dat a html Luckyloot tabulky vyhier
                    var bonusBallKey = new RegExp(/^(hits_\d+B)$/); // "hits_#B"
                    var bonusBall = false;

                    // Lucky Loot
                    if (data.LCUP == 624204) {
                        allData = lotteryOffer.league624204.balls;
                        bonusBall = true; // Luckyloot ma v datach pre lopticky aj bonus (×2)
                    }        
                    // Keno
                    if (data.LCUP == 624205) {
                        allData = lotteryOffer.league624205.balls;
                    }
                    
                    Object.entries(allData).forEach(([key, tableData]) => {
                        
                        // osetrujem to aby som pracoval len so sancami pre pocet lopticiek a nie ine data z objektu napr: "chanceTypeID"
                        if (isNaN(key)) return;
                        
                        Object.entries(tableData).forEach(([key, value]) => {
                            
                            // osetrujem to aby som pracoval len so sancami pre pocet lopticiek a nie ine data z objektu napr: "chanceTypeID - tabulka luckyloot"
                            if (typeof value != 'object') return;
                            
                            // vyhadzujem Luckyloot bonus riadok a nasobim manualne v html (pays × 2)
                            if (bonusBallKey.test(key)) return;

                            rowHtml += `
                                <tr>
                                    <td>${key.replace("hits_","")}</td>
                                    <td><span class="chip">${shared.floor2(value.pays, 2)}</span></td>
                                    ${bonusBall ? '<td><span class="bonus">' + shared.floor2(value.pays * 2, 2) + '</span></td>' : ''}
                                </tr>
                            `;
                        });

                        tableHtml = `
                            <input type="radio" name="toggle-lottery-table" id="lottery-tabid-${key}" class="lottery-help-table__toggle" value="${key}" ${key == 1 ? 'checked' : ''}>
                            <label for="lottery-tabid-${key}" class="lottery-help-table__toggle-label">${key}</label>
                            <div class="lottery-help-table__toggle-tab">
                                <table class="lottery-help-table__table">
                                    <thead>
                                        <tr>
                                            <th>${texts.LotteryBetTableHeaderHits}</th>
                                            <th>${texts.LotteryBetTableHeaderPays}</th>
                                            ${bonusBall ? '<th>' + texts.LotteryBetTableHeaderBonus + '</th>' : ''}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${rowHtml}
                                    </tbody>
                                </table>
                            </div>
                        `;

                        allTablesHtml += tableHtml;
                        tableHtml = rowHtml = "";
                    });

                    return `<div class="lottery-help-table ${data.LCUP == 624205 ? 'keno' : 'luckyloot'}">${allTablesHtml}</div>`;
                }
            } catch (e) {
                main.createLog(2, "eventDetailLottery.getAllTables", " # ERROR: " + e);
                return false;
            }
        },

        // vygenerovanie riadka s loteriami z vysledkov tahu
        getBalls: function(data) { 
            try {
                if (data) {
                    var ballsHtml = "";
                    var rowHtml = "";
                    var balls = data.SCORENEW;
                    // osetrenie pola lopticiek
                    balls = balls.split("=")[1].split(",");

                    // Lucky Loot
                    if (data.LCUP == 624204) {
                        var bonusBall = true; // TODO - ako zistim bonus ball
                        balls.forEach((ball) => {
                            var ballColor;
                            if (ball < 13) {
                                ballColor = ball % 2 ? "green" : "yellow";
                            } else {
                                ballColor = ball % 2 ? "blue" : "red";
                            };

                            rowHtml += `<span class="lottery-draw__ball ${ballColor}"><b>${ball}</b></span>`;
                        })
                        if (bonusBall) {
                            rowHtml += `<span class="lottery-draw__ball bonus">Bonus ball</span>`;
                        }
                    }

                    // Keno
                    if (data.LCUP == 624205) {
                        var ballsHeads = [];
                        var ballsTails = [];
                        balls.forEach((ball) => {
                            if ((ball * 1) > 40) {
                                ballsTails.push(ball);
                            } else {
                                ballsHeads.push(ball);
                            }
                        })

                        // pridavam nadpis 1. bloku
                        rowHtml += `<h5 class="lottery-draw__balls-title">${texts.LotteryBetKenoTitleHeads}</h5>`;

                        if (ballsHeads.length) {
                            ballsHeads.sort(function(a, b){return a - b}).forEach((ball) => {
                                rowHtml += `<span class="lottery-draw__ball heads"><b>${ball}</b></span>`
                            });
                        }

                        // pridavam koniec 1. bloku, zaciatok 2. bloku a nadpis
                        rowHtml += `</div><div class="lottery-draw__balls"><h5 class="lottery-draw__balls-title">${texts.LotteryBetKenoTitleTails}</h5>`;
                        
                        if (ballsTails.length) {
                            ballsTails.sort(function(a, b){return a - b}).forEach((ball) => {
                                rowHtml += `<span class="lottery-draw__ball tails"><b>${ball}</b></span>`
                            });
                        }
                    }

                    ballsHtml = `
                        <tr class="lottery-detail">
                            <td colspan="8">
                                <div class="lottery-draw__container">
                                    <div class="lottery-draw">
                                        <!-- Balls -->
                                        <h5 class="lottery-draw__title">${texts.LotteryBetKenoTitleDraw}</h5>
                                        <div class="lottery-draw__balls">
                                            ${rowHtml}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    `;

                    return ballsHtml;
                }
            } catch (e) {
                main.createLog(2, "eventDetailLottery.getBalls", " # ERROR: " + e);
                return false;
            }
        },

        // volanie pre naplnenie detailu tipu (rozbalovaci riadok) v druhom riadku podľa tipu a stavu
        getDetails: function(a) {

            switch (a.item?.ChanceTypeID) {

                // KENO
                case "uf:5019": // Win - balls
                    switch (a.item.IsWinning) {
                        case "Y": // Výherný
                        case "N": // Nevýherný
                            return `${this.eventDetailLottery.getBalls(a.item)} ${this.eventDetailLottery.getTable(a.item)}`;
                        case "U": // Nevyhodnotený
                            return this.eventDetailLottery.getTable(a.item);
                        default:
                            return "";
                    }

                case "uf:5030": // Heads and Tails
                    switch (a.item.IsWinning) {
                        case "Y": // Výherný
                        case "N": // Nevýherný
                            return this.eventDetailLottery.getBalls(a.item);
                        case "U": // Nevyhodnotený
                            a.item.collapsibleRow = false;
                            return "";
                        default:
                            return "";
                    }

                // TODO - luckyloot
                default:
                    return "";
            }
        }
    },

    // Funkcia na renderovanie virtualnych hier
    lotteryGamesRender: function(data) {
        try {
            if (data && data[0] && data[0].EventCount && !data.ErrorType) {
                $("#home, #empty").hide();
                $("#sportsBook, #sportsBookVG, #sportsBookLG").empty().hide();
                $(".content-offer, #eventsIframeWrapper").addClass("ui-disabled");
                // Vyfiltruje len povolene ligy (Providers) loteriovych hier pre dohodnute profile.Lottery.RegionID
                var leagues = data.filter(function(VS) {
                    if (VS.Typ === "LC" && VS.ParentID === profile.Lottery.RegionID && profile.Lottery.Providers.includes(VS.Provider)) {
                        return VS;
                    }
                }).sort(function(lA, lB) {
                    return lA.Order - lB.Order;
                });
                if (leagues && leagues[0]) {
                    $p("#sportsBookLG").render(leagues, T.sportsBookLG);
                    $("#sportsBookLG").trigger("create");

                    // Scroll buttonov
                    $("#sportBox .ui-content #offerBottom .arrows").removeAttr("style");
                    setTimeout(function() {
                        shared.scrollModule.scrollButtons("offerLG");
                        // Rozklikne prvu loteriovu hru
                        lottery.lotteryGameRender(leagues[0].ParentID, leagues[0].ID);
                    });
                    // Zobrazenie tlacidiel hlasitosti
                    if (profile.HaveSound) $("#setVolumeToggle").show();

                    return true;
                } else {
                    modal.showErrObj(2, 5, {err1: texts.BallGamesBlocked, errType: "BallGamesBlocked"});
                    main.setPage(2);
                    return false;
                }
            } else {
                modal.showErrObj(2, 5, {err1: texts.BallGamesBlocked, errType: "BallGamesBlocked"});
                main.setPage(2);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $(".content-offer").removeClass("ui-disabled");
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.setPage(1);
            return false;
        }
    },

    // Funkcia sluzi na uzamknutie vsetkych iframe loterie
    // Po exspiracii n oddov a po zavolani ticket.ticketOddModule.removeOddsExp() ide n /lotteryrem/ requestov na ticketWS, vtedy sa zavola lottery.lockLotteryIframe().
    // Aby sa zabranilo nekonzistnemu stavu na webApp, pocka sa dokym dobehne tychto n requestov a az potom hracovi dovolime akciu (pridavanie oddov z lottery iframe -lottery.lockLotteryIframe())
    lockLotteryIframe: function() {
        try {
            $("#eventsIframeWrapper .lottery-game-iframe").addClass("lottery-game-iframe-locked");
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na odomknutie vsetkych iframe lotterie
    unlockLotteryIframe: function() {
        try {
            $("#eventsIframeWrapper .lottery-game-iframe").removeClass("lottery-game-iframe-locked");
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na renderovanie loteriovych hier
    lotteryGameRender: function(VSID, VLID) {
        try {
            if (VSID && VLID) {
                $("#events").hide();
                $(".content-offer, #eventsIframeWrapper").addClass("ui-disabled");
                shared.scrollModule.scrollButtons("offerLG");
                // Zrusenie inline detailu zapasu
                if (offer.eventID) main.closeDialog();
                stored.topScreenActive = "lottery";
                stored.topScreenBgLeague = VLID;
                communication.topScreen(stored.topScreenActive, {
                    screenShow: true,
                    gameID: VSID,
                    leagueID: stored.topScreenBgLeague
                });
                // Oznaci button zvolenej loteriovej hry
                $("#sportsBookLG .lottery-game").removeClass("lottery-league-active").end()
                    .find("#LC" + VLID).addClass("lottery-league-active");

                // Render ponuky
                offer.sportID = offer.lgID;
                offer.regionID = VSID;
                offer.leagueCupID = VLID;
                service.loadPure("sportsBookEventsLotteryGames");
                $(".content-offer").removeClass("ui-disabled");
                return true;
            } else {
                $(".content-offer").removeClass("ui-disabled");
                modal.showErrObj(2, 5, {err1: texts.BallGamesBlocked, errType: "BallGamesBlocked"});
                main.setPage(2);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $(".content-offer").removeClass("ui-disabled");
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.setPage(1);
            return false;
        }
    }
};
